import { Room } from '../../../state/rooms.repository';
import { isWithinSchedule } from '../../../shared/models/schedule';

/**
 * Whether the tile's door is drawn closed, i.e. the user would have to knock
 * (request approval) instead of joining directly. Client-side mirror of the
 * server's join gate — the server remains authoritative and may still decide
 * differently (invites, races at schedule boundaries); see the knock messaging
 * in `join-approval-overlay.component.ts`, which applies the same heuristic.
 *
 * A password (`hasPassword`) does NOT close the door: the user can enter it
 * themselves without anyone's approval. `bypassesGate` is the user's
 * `bypassesJoinGate` privilege state (manageRooms, grantAccess or joinAnyRoom).
 */
export function isDoorClosed(room: Room, now: number, bypassesGate: boolean): boolean {
  if (bypassesGate) return false;
  if (room.isPrivate) return true;
  return !!room.schedule && !isWithinSchedule(room.schedule, now);
}
